import styled from '@emotion/styled';
import { memo } from 'react';
import { Tag } from 'react-feather';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 12px;
  color: #aaa;
`;

const Message = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #555;
  margin: 0;
`;

const Note = styled.p`
  font-size: 13px;
  color: #999;
  margin: 0;
`;

export const TagsTableEmpty = memo(() => (
  <Wrap>
    <Tag size={64} />
    <Message>No tags available.</Message>
    <Note>Set up tags to structure quotes from interviews.</Note>
  </Wrap>
));

TagsTableEmpty.displayName = 'Project.Tags.Table.Empty';
